import type { Nullable } from '~/core/types'
import type { Position } from '~/core/types/shared'

export function useLocation() {
  const runtimeConfig = useRuntimeConfig()

  const loadingLocation = ref(true)
  const locationEnabled = ref(false)

  const geoLocation = ref<Nullable<Position>>(null)

  async function getLocation(): Promise<Nullable<Position>> {
    try {
      loadingLocation.value = true
      const location = await currentLocation(runtimeConfig.public.isMobile, { timeout: 3000 })
      if (!location) {
        throw Error('Error while retrieving location')
      }

      return {
        latitude: Math.round(location.coords.latitude * 1000000) / 1000000,
        longitude: Math.round(location.coords.longitude * 1000000) / 1000000,
      }
    } catch (e) {
      const { message } = e as GeolocationPositionError
      console.warn(message)
      return null
    } finally {
      loadingLocation.value = false
    }
  }

  onMounted(async () => {
    if (import.meta.server) {
      return
    }
    const isMobile = runtimeConfig.public.isMobile
    try {
      const res = await checkPermission(isMobile)
      locationEnabled.value = res !== null
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      locationEnabled.value = false
    }

    if (locationEnabled.value) {
      geoLocation.value = await getLocation()
    } else {
      loadingLocation.value = false
    }
  })

  return {
    geoLocation,
    locationEnabled,
  }
}
